module.exports = __webpack_public_path__ + "static/mag.9514f160.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/mag.jpg
// module id = 537
// module chunks = 95715928098905 264598414423048